import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";
import { API_BASE_URLS } from "../../utils/constant";
import { CmsType } from "../../@customTypes/cms";
import axiosInstance from "../../utils/axios";

type CMSState = {
  isLoading: boolean;
  error: boolean;
  success: boolean;
  cmsDetails: CmsType | null;
  cmsList: CmsType[];
  selectedCms: CmsType | null;
};

const initialState: CMSState = {
  isLoading: false,
  error: false,
  success: false,
  cmsDetails: null,
  cmsList: [],
  selectedCms: null
};

const slice = createSlice({
  name: "cms",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // IS SUCCESS
    isSuccess(state, action) {
      state.isLoading = false;
      state.success = action.payload;
    },
    // CMS LISTING
    getCMSListSuccess(state, action) {
      state.isLoading = false;
      state.cmsList = action.payload;
    },
    getSelectedCMSSuccess(state, action) {
      state.isLoading = false;
      state.selectedCms = action.payload;
    },
    removeSelected(state) {
      state.isLoading = false;
      state.selectedCms = null;
    }
  }
});

// Reducer
export default slice.reducer;

export function getCMSById({ id }: { id: number }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response: any = await axiosInstance.get(
        `${API_BASE_URLS.cms_page}/${id}`
      );
      if (response?.error) {
        throw new Error(response?.error);
      } else {
        dispatch(slice.actions.getSelectedCMSSuccess(response.data));
        return response.data;
      }
    } catch (error: any) {
      dispatch(slice.actions.hasError(error));
      throw new Error(error.message);
    }
  };
}

export function getCMSList({ payload }: { payload: any }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response: any = await axiosInstance.post(
        `${API_BASE_URLS.cms_page}/list`,
        payload
      );
      if (response?.error) {
        throw new Error(response?.error);
      } else dispatch(slice.actions.getCMSListSuccess(response.data));
    } catch (error: any) {
      dispatch(slice.actions.hasError(error));
      throw new Error(error.message);
    }
  };
}

export function deleteCMS({ id }: { id: number }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response: any = await axiosInstance.delete(
        `${API_BASE_URLS.cms_page}/${id}/delete`
      );
      if (response?.error) {
        throw new Error(response?.error);
      }
    } catch (error: any) {
      dispatch(slice.actions.hasError(error));
      throw new Error(error.message);
    }
  };
}

export function editCMS({ payload }: { payload: any }) {
  const { id, ...restPayload } = payload;
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response: any = await axiosInstance.post(
        `${API_BASE_URLS.cms_page}/${id}/edit`,
        restPayload
      );
      if (response?.error) {
        throw new Error(response?.error);
      }
    } catch (error: any) {
      dispatch(slice.actions.hasError(error));
      throw new Error(error.message);
    }
  };
}

export function addCMS({ payload }: { payload: any }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response: any = await axiosInstance.post(
        `${API_BASE_URLS.cms_page}/add`,
        payload
      );
      if (response?.error) {
        throw new Error(response?.error);
      }
    } catch (error: any) {
      dispatch(slice.actions.hasError(error));
      throw new Error(error.message);
    }
  };
}

export function startLoading() {
  return async () => dispatch(startLoading);
}

export function stopLoading() {
  return async () => dispatch(stopLoading);
}

export function removeError() {
  return async () => dispatch(slice.actions.hasError(false));
}

export function setSuccess(payload: boolean) {
  return async () => dispatch(slice.actions.isSuccess(payload));
}
export function removeSelectedCMS() {
  return async () => dispatch(slice.actions.removeSelected());
}
